export default {
      id: "icon-3dots-usage",
      viewBox: "0 0 24 24",
      url: "/" + "assets/sprite.svg#icon-3dots",
      toString: function () {
        return this.url;
      }
    }